import { render } from "./HomeStaticLine.vue?vue&type=template&id=cdf5335a"
import script from "./HomeStaticLine.vue?vue&type=script&lang=js"
export * from "./HomeStaticLine.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__